import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Select from 'react-select'

class EventFulfillRiderRequestModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedRider: undefined,
      error: null
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    const { selectedRider } = this.state

    if (!selectedRider) {
      this.setState({error: 'Please select your rider.'})
    } else {
      this.setState({error: null}, () => this.props.fulfillRiderRequest(selectedRider.id))
    }
  }

  render() {
    const { riderRequest, riders } = this.props
    const { selectedRider, error } = this.state

    return (
      <div className="modal-content">
        <h3>Send a rider</h3>

        {
          riders.length > 0
          ? <form onSubmit={this.onSubmit}>
              <div className="select-form">
                <ul className="group" data-error-msg={error}>
                  {
                    riderRequest.description
                    ? <li data-title="Notes from event organizer">
                        <i>{riderRequest.description}</i>
                      </li>
                    : null
                  }

                  <li data-title="Select your rider">
                    <div className="select-form-fields">
                      <Select
                        cache={false}
                        autoFocus={false}
                        openOnFocus={true}
                        className="select-form-field"
                        value={selectedRider}
                        valueKey="id"
                        labelKey="title"
                        clearable={false}
                        placeholder={null}
                        onChange={(selectedRider) => this.setState({selectedRider})}
                        options={riders} />
                    </div>
                  </li>
                </ul>

                <button className="button--primary" type="submit">Send rider</button>
              </div>
            </form>
          : <div>
              <p>{`Oops, seems like you doesn't have any riders yet.`}</p>
              <a onClick={() => this.props.setModal('RiderCreateModal')}>Start by creating one now.</a>
            </div>
        }
      </div>
    )
  }
}

EventFulfillRiderRequestModal.propTypes = {
  riderRequest: PropTypes.object,
  riders: PropTypes.array,
  fulfillRiderRequest: PropTypes.func,
  setModal: PropTypes.func
}

EventFulfillRiderRequestModal.defaultProps = {
  riderRequest: {},
  riders: [],
  fulfillRiderRequest: function() {},
  setModal: function() {}
}

export default EventFulfillRiderRequestModal



// WEBPACK FOOTER //
// ./src/components/modals/event-fulfill-rider-request-modal.js